import React, { useState } from "react"
import {
  Card,
  CardBody,
} from "reactstrap"
import SimpleBar from "simplebar-react"
import PropTypes from 'prop-types';

const AppraisalTimeline = props => {
    const notofications = [
        {  desc: "Performance Agreement"  },
        {  desc: "Performance Agreement Lines"  },
        {  desc: "Approval by Supervisor"  },
        {  desc: "Convert to Appraisal"  },
        {  desc: "Fill out Appraisal" },
        {  desc: "Supervisor Comments" },
        {  desc: "Appraisal Grading" },
        {  desc: "Improvement Plan" },
      ]

      return (

            <>
                <SimpleBar style={{ height: "440px" }}>
                    <ul className="verti-timeline list-unstyled">
                    {notofications.map((notification, key) => (
                    <li key={key} className="event-list">
                        <div className="event-timeline-dot">
                        <i className={(key == props.stage) ? `bx bx-right-arrow-circle font-size-20 text-danger bx-fade-right`:`bx bx-right-arrow-circle font-size-18`} />
                        </div>
                        <div className="d-flex">
                        <div className="me-3">
                            <h5 className="font-size-14">
                            {notification.date}{" "}
                            <i className={(key == props.stage)? `bx bx-right-arrow-alt font-size-16 text-danger align-middle ms-2 bx-fade-right` : `bx bx-right-arrow-alt font-size-16  align-middle ms-2`}/>
                            </h5>
                        </div>
                        <div className="flex-grow-1">
                            <div>{(key == props.stage) ? <strong className="text-primary">{notification.desc}</strong> : <>{notification.desc}</>} </div>
                        </div>
                        </div>
                    </li>
                    ))}
                    </ul>
                    </SimpleBar>
                    </>
    )
  }
  AppraisalTimeline.propTypes = {
    stage: PropTypes.any
  };
  export default AppraisalTimeline